import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setAuthToken: (state, action) => {
      state.token = action.payload;
    },
    logOut: (state) => {
      state.token = '';
      state.user = null;
    },
  },
});

export const { setAuthToken, setUser, logOut } =
  authSlice.actions;

export default authSlice.reducer;
